// extracted by mini-css-extract-plugin
export default {"newItem":"NewItemIndicator-m_newItem-q_BtCwjv"};